export default __webpack_public_path__ + "static/fa-regular-400-4689f52cc96215721344e51e5831eec1.svg";